<div class="thumbnail-item-container" 
     [class.selected]="isSelected" 
     [class.active]="isActive"
     (contextmenu)="onContextMenu($event)">
  
  <!-- Context Menu Trigger (invisible, for positioning) -->
  <div style="visibility: hidden; position: fixed"
       [style.left]="contextMenuPosition.x"
       [style.top]="contextMenuPosition.y"
       [matMenuTriggerFor]="contextMenu"
       #contextMenuTrigger="matMenuTrigger">
  </div>
  
  <!-- Context Menu -->
  <mat-menu #contextMenu="matMenu">
    <button mat-menu-item (click)="thumbnailClicked.emit()">
      <mat-icon>visibility</mat-icon>
      <span>View Image</span>
    </button>
    <button mat-menu-item (click)="previewClicked.emit()">
      <mat-icon>open_in_new</mat-icon>
      <span>Preview in New Tab</span>
    </button>
    <button mat-menu-item (click)="openExternalClicked.emit()">
      <mat-icon>edit</mat-icon>
      <span>Open in External Editor</span>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="onExcludeClick()">
      <mat-icon>block</mat-icon>
      <span>Exclude from Selection</span>
    </button>
    <button mat-menu-item (click)="deleteClicked.emit()">
      <mat-icon color="warn">delete</mat-icon>
      <span>Delete Image</span>
    </button>
  </mat-menu>

  <!-- Main horizontal layout: Checkbox | Content -->
  <div class="item-layout">
    <!-- Checkbox on left -->
    <div class="checkbox-column">
      <mat-checkbox 
        [checked]="isSelected"
        (change)="onCheckboxChange($event)"
        (click)="$event.stopPropagation()">
      </mat-checkbox>
    </div>
    
    <!-- Content column: Thumbnail + Filename -->
    <div class="content-column">
      <!-- Thumbnail container with overlay buttons -->
      <div class="thumbnail-wrapper" (click)="onThumbnailClick($event)">
        <img 
          [src]="thumbnailUrl" 
          [alt]="displayName"
          loading="lazy"
          (error)="onImageError($event)">
        
        <!-- Overlay buttons (Snagit + Delete) - positioned top-left like Python UI -->
        <button class="overlay-btn snagit-btn" 
                (click)="onSnagitClick($event)" 
                matTooltip="Open in External Editor">
          <mat-icon>edit</mat-icon>
        </button>
        <button class="overlay-btn delete-btn" 
                (click)="onDeleteClick($event)" 
                matTooltip="Delete this image">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      
      <!-- Filename below thumbnail (centered, clickable link style) -->
      <div class="filename-row">
        <span class="filename" [title]="image.filename" (click)="onFilenameClick($event)">
          {{ displayName }}
        </span>
        <span class="dimensions" *ngIf="image?.width && image?.height">
          {{ image.width }}×{{ image.height }}
        </span>
      </div>
    </div>
  </div>
  
  <!-- Selection order badge (shown when selected) -->
  <div class="selection-order" *ngIf="selectionOrder > 0">
    {{ selectionOrder }}
  </div>
</div>
